import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HistoryInventory } from 'app/models2/inventory/history-inventory';
import { InputOrOutputInventory } from 'app/models2/inventory/input-or-output-inventory';
import { Warehouse } from 'app/models2/inventory/warehouse';
import { Resources } from 'app/models2/maintenance/resources';
import { UtilsServiceService } from 'app/services/utils-service.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  FunctionsService,
  HeaderFilters,
  HttpService,
  MenuBreadCrumb,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';

@Component({
  selector: 'app-inputs',
  templateUrl: './inputs.component.html',
  styleUrls: ['./inputs.component.scss']
})
export class InputsComponent implements OnInit {
  public urlTableII: string = `${EndpointDictionary.InventoryInputsHistory.INVENT_INPUT_HISTORY_TABLE}`;
  private urlPostII: string = `${EndpointDictionary.InventoryInputsHistory.CRUD_INVENT_INPUT_HISTORY_DATA}`;
  private urlProvider: string = `${EndpointDictionary.Provider.PROVIDER_COMBO}`;
  private urlUser: string = `${EndpointDictionary.User.USER_COMBO}`;
  private urlCrudPO: string = `${EndpointDictionary.PurchaseOrder.CRUD_PURCHASE_ORDER}`;
  private urlItems: string = `${EndpointDictionary.Item.ITEM_COMBO}`;
  private urlWarehouses: string = `${EndpointDictionary.Warehouse.WAREHOUSE_COMBO}`;

  public labels = []
  public selected = new UntypedFormControl(0);
  public dataPO = new HistoryInventory
  public movil: boolean
  public havePurchaseOrder: boolean = false
  public warehouses: Warehouse[]

  public reloadTablaII = new EventEmitter<any>();
  public configurationII: TableConfiguration = {
    edit: false,
    add: true,
    delete: false,
    selectable: false,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    print: false,
    exportXslx: true,
    hideTitle: true,
    view: true,
  };

  public columnsII: TableColumns<HistoryInventory>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
    },
    {
      ID: 'date',
      label: 'Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'warehouse',
      label: 'Bodega',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'userName',
      label: 'Responsable',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'providerName',
      label: 'Proveedor',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'totalCost',
      label: 'Costo Total',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'itemsCount',
      label: 'Número de Items',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'orderNumber',
      label: '# Orden Compra',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  headerFileXlsm: Array<params> = [
    { id: 'consecutive', value: 'Consecutivo' },
    { id: 'date', value: 'Fecha de Registro' },
    { id: 'warehouse', value: 'Bodega' },
    { id: 'userName', value: 'Responsable' },
    { id: 'userId', value: 'Cédula' },
    { id: 'providerName', value: 'Proveedor' },
    { id: 'totalCost', value: 'Costo Total' },
    { id: 'itemsCount', value: 'Número de Items' },
    { id: 'orderNumber', value: '# Orden Compra' },
  ];

  // tabla detalle historico
  public reloadTablaDetails = new EventEmitter<any>();
  public dataDetails: Array<InputOrOutputInventory> = [];
  public configurationDetails: TableConfiguration = {
    exportXslx: true,
    hideTitle: true,
    primaryKey: 'id',
  };
  public columnsDetails: TableColumns<InputOrOutputInventory>[] = [
    {
      ID: 'code',
      label: 'Código Item',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'itemName',
      label: 'Item',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'costItem',
      label: 'Costo Unitario',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'totalCostItems',
      label: 'Costo Total Items',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
  ];

  // tabla rescursos orden de compra
  public dataResoucesPO: Array<InputOrOutputInventory> = [];
  public configurationResoucesPO: TableConfiguration = {
    hideTitle: true,
    primaryKey: 'id',
  };

  headerDetailsFileXlsm: Array<params> = [
    { id: 'code', value: 'Código Item' },
    { id: 'itemName', value: 'Nombre Item' },
    { id: 'amount', value: 'Cantidad' },
    { id: 'unitMeasurement', value: 'Unidad' },
    { id: 'costItem', value: 'Costo Unidad' },
    { id: 'totalCostItems', value: 'Costo Total' },
    { id: 'description', value: 'Descripción Item' },
    { id: null, value: '' },
    { id: null, value: '' },
    { id: null, value: '' },
    { id: null, value: '' },
    { id: null, value: '' },
  ];

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Almacén Entradas',
      current: true,
    },
  ];

  headerFilters: Array<HeaderFilters> = [];

  constructor(
    private session: SessionService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private http: HttpService,
    private functionEter: FunctionsService,
    private utils: UtilsServiceService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  async ngOnInit() {
    this.movil = screen.width > 600 ? false : true;
    window.addEventListener('resize', () => {
      this.movil = screen.width > 600 ? false : true;
    });

    this.warehouses = await this.http.getDataBody(`${this.urlWarehouses}`, [
      { id: 'active', value: 1 }
    ]);

    this.initFilters(this.warehouses);
  }

  initFilters(warehouse: Warehouse[]) {
    var value = '';
    if (this.warehouses.length === 1) {
      value = this.warehouses[0].id.toString();
    }

    this.headerFilters = [
      {
        tN: 'bodegas',
        labelFilter: 'Bodegas',
        visibleField: 'name',
        primaryKey: 'id',
        type: 'select',
        value: value,
        active: true,
        data: warehouse,
      },
      {
        tN: 'item_inventario',
        labelFilter: 'Item',
        urlData: this.urlItems,
        visibleField: 'itemName',
        primaryKey: 'id',
        type: 'select',
        value: '',
      },
      {
        tN: 'terceros',
        labelFilter: 'Proveedor',
        urlData: this.urlProvider,
        visibleField: 'providerName',
        primaryKey: 'id',
        type: 'select',
        value: '',
      },
      {
        tN: 'usuarios',
        labelFilter: 'Responsable',
        urlData: this.urlUser,
        visibleField: 'name',
        primaryKey: 'userId',
        type: 'select',
        value: '',
      },
      {
        tN: 'hei',
        visibleField: 'fecha',
        type: 'date',
        value: '',
      },
      {
        tN: 'hei',
        visibleField: 'fecha',
        type: 'dateRange',
        value: '',
      }]


  }

  addII($event: HistoryInventory) {
    let warehouseIdSelected = this.headerFilters[0].value;
    let queryParams = warehouseIdSelected ? { warehouseId: warehouseIdSelected } : {};
    this.router.navigate(['detalle'], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
    });
  }

  async editII($event: HistoryInventory) {
    let res: boolean = await this.getDataII($event[0].id);
    if (res) {
      this.router.navigate(['detalle'], { relativeTo: this.activeRoute });
    }
  }

  async getDataII(id: number) {
    let res = await this.http.getDataBody<Array<HistoryInventory>>(
      `${this.urlPostII}/${id}`
    );
    if (res) {
      this.session.setData('data', { action: 'edit', body: res });
      return true;
    } else {
      return false;
    }
  }

  async viewDetail($event: HistoryInventory[]) {
    this.selected.setValue(1);
    let res = await this.http.getDataBody<Array<HistoryInventory>>(
      `${this.urlPostII}/${$event[0].id}`
    );
    if (res) {
      this.havePurchaseOrder = res[0].purchaseOrderId > 0 ? true : false;
      this.dataDetails = res[0].items;
      this.labelsFunction(res[0]);
      if (!this.havePurchaseOrder) return;

      let resPO = await this.http.getDataBody<Array<HistoryInventory>>(
        `${this.urlCrudPO}/${res[0].purchaseOrderId}`
      );
      if (resPO.length > 0) {
        this.dataResoucesPO = resPO[0].items;
        this.dataPO = resPO[0];
        this.dataPO.receptionDate = this.functionEter.dateIso(
          resPO[0].receptionDate
        );
      }
    }
  }

  private labelsFunction(dataHI: HistoryInventory) {
    this.labels = [
      {
        label: 'Consecutivo (#):',
        value: dataHI.consecutive,
        edit: false,
      },
      {
        label: 'Responsable:',
        value: dataHI.userName,
        edit: false,
      },
      {
        label: 'Fecha:',
        value: this.functionEter.dateDB(new Date(dataHI.date)),
        edit: false,
      },
      {
        label: 'Total:',
        value: `$  ${Intl.NumberFormat('es-CO').format(dataHI.totalCost)}`,
        edit: false,
      },
      {
        label: 'Bodega:',
        value: dataHI.warehouse,
        edit: false,
      },
    ];

    if (dataHI?.comment != '') {
      this.labels.push({
        label: 'Comentario:',
        value: dataHI.comment,
        edit: false,
      });
      this.headerDetailsFileXlsm[11] = {
        id: null,
        value: `Comentario: ${dataHI.comment}`,
      };
    }
    if (dataHI.purchaseOrderId) {
      this.labels.push({
        label: 'Orden #:',
        value: dataHI.orderNumber,
        edit: false,
      });
      this.headerDetailsFileXlsm[12] = {
        id: null,
        value: `Orden de Trabajo: ${dataHI.purchaseOrderId}`,
      };
    }
    (this.headerDetailsFileXlsm[7] = {
      id: null,
      value: `Consecutivo (#): ${dataHI.consecutive}`,
    }),
      (this.headerDetailsFileXlsm[8] = {
        id: null,
        value: `Responsable: ${dataHI.userName}`,
      }),
      (this.headerDetailsFileXlsm[9] = {
        id: null,
        value: `Fecha de creación:${this.functionEter.dateDB(
          new Date(dataHI.date)
        )}`,
      }),
      (this.headerDetailsFileXlsm[10] = {
        id: null,
        value: `Costo Total: $  ${Intl.NumberFormat('es-CO').format(
          dataHI.totalCost
        )}`,
      });
  }
}
